{
  "version": 1,
  "asset_id": "9f02a52a-2570-4658-859e-1edb29d119ed",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/9f02a52a-2570-4658-859e-1edb29d119ed/avatar-96.jpg",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/9f02a52a-2570-4658-859e-1edb29d119ed/avatar-96.jpg",
  "original_filename": "avatar-96.jpg",
  "size": 3228,
  "content_type": "image/jpeg",
  "created_at": "2026-06-25T01:16:11Z"
}
